import { Box, Card, Chip, IconButton, Modal, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { BookingDetailsContext } from './Viewdetails';
import { formatDateTime } from '../../../utils/dateUtils';
import CloseIcon from '@mui/icons-material/Close';
import PaymentDescription from './PaymentDescription';
import AddPaymentRecord from '../payment/AddPaymentRecord';
import PaymentRecordsList from './PaymentRecordsList';
import { PaymentServices } from '../../Payment/Booking/BookingPaymentServices';

const PaymentDetails = ({ selectedBookingDetails }) => {
  const { bookingDetailsdata,fetchBookingDetalById } = useContext(BookingDetailsContext)
  const paymentData = bookingDetailsdata?.payment;
  const [viewDetails, setViewDetails] = useState(false);
  const [newPaymentEntry, setNewPaymentEntry] = useState(false);
  const [showPaymentHistory, setShowPaymentHistory] = useState(false);
  const [paymentRecords, setPaymentRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchBookingPaymentRecords = async()=>{
    setLoading(true);
    const response = await PaymentServices.fetchBookingPaymentRecords(bookingDetailsdata?.id);
    if(response.success == '1'){
      setPaymentRecords(response.data);
    } else if(response.success == '0'){
      setPaymentRecords([]);
    }
    setLoading(false);
  };
  useEffect(() => {
    if(bookingDetailsdata?.id){
      fetchBookingPaymentRecords();
    }
  }, [bookingDetailsdata]);
  return (
    <Card>
      <Box sx={{ px: '2%', borderBottom: '1px solid #E0E0E0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: '1%' }}>
          <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>{`Payment Summary`}</Typography>
        </Box>
      </Box>
      <Box sx={{}}>
        <Box sx={{ display: 'flex', alignItems: 'center', px: 1, py: 0.5 }}>
          <Typography sx={{ width: '40%', fontSize: '0.75rem', fontWeight: 600 }}>Payment Status </Typography>
          <Box sx={{ fontSize: '0.65rem' }}>:
            <Chip
              label={paymentData?.status}
              size="small"
              sx={{
                // ml:1,
                height: '1rem',
                fontSize: '0.5rem',
                fontWeight: '500',
                padding: '0.1rem 0.2rem',
                color: paymentData?.status == 'PENDING' ? '#E8832A' : paymentData?.status == 'SUCCESS' ? '#009EB4' : 'default',
                bgcolor: paymentData?.status == 'PENDING' ? '#FFEDD5' : paymentData?.status == 'SUCCESS' ? '#009eb442' : 'default'
              }}
            />
          </Box>
        </Box>
        {paymentData?.status == 'SUCCESS' &&
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', px: 1, py: 0.5 }}>
              <Typography sx={{ width: '40%', fontSize: '0.75rem', fontWeight: 600 }}>Transaction No.</Typography>
              <Typography sx={{ fontSize: '0.65rem' }}>: {paymentData?.transactionNumber}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', px: 1, py: 0.5 }}>
              <Typography sx={{ width: '40%', fontSize: '0.75rem', fontWeight: 600 }}>Payment Amount</Typography>
              <Typography sx={{ fontSize: '0.65rem' }}>: ₹{parseFloat(paymentData?.amount).toFixed(2)}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', px: 1, py: 0.5 }}>
              <Typography sx={{ width: '40%', fontSize: '0.75rem', fontWeight: 600 }}>Payment Method </Typography>
              <Typography sx={{ fontSize: '0.65rem' }}>: {paymentData?.paymentMethod}</Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', px: 1, py: 0.5 }}>
              <Typography sx={{ width: '40%', fontSize: '0.75rem', fontWeight: 600 }}>Transaction Date </Typography>
              <Typography sx={{ fontSize: '0.65rem' }}>: {paymentData?.paymentCreatedDate ? formatDateTime(paymentData?.paymentCreatedDate) : ''}</Typography>
            </Box>
          </>
        }
      </Box>
      {/* {bookingDetailsdata?.bookingStatus == 'completed' && */}
        <Box sx={{display:'flex', justifyContent: {xs: 'space-between'}, p: '2%' }}>
          <Typography sx={{ fontSize: '0.65rem', color: '#1976d2', cursor: 'pointer' }} onClick={() => setNewPaymentEntry(true)}>Add Details </Typography>
          {
            paymentRecords.length > 0 &&
            <Typography sx={{ fontSize: '0.65rem', color: '#1976d2', cursor: 'pointer' }} onClick={() => setShowPaymentHistory(true)}>Payment History </Typography>
          }
          <Typography sx={{ fontSize: '0.65rem', color: '#1976d2', cursor: 'pointer' }} onClick={() => setViewDetails(true)}>View More </Typography>
        </Box>
      {/* // } */}

      <Modal
        open={viewDetails}
        // onClose={() => setOpenServiceDropdown(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50%', sm: '50%' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 0,
            width: { xs: "95%", sm: "30%" },
            minHeight: '25%'
          }}

          borderRadius={2}
        >
          <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
              Payment Detail's
            </Typography>
            <IconButton
              size='small'
              onClick={()=>setViewDetails(false)}
              sx={{ p: 0 }}
              color='error'
            >
              <CloseIcon sx={{fontSize:{xs:'1rem',sm:'1.25rem'}}}/>
            </IconButton>
          </Box>
          <PaymentDescription/>
        </Box>
      </Modal>
      {/* ========== Payment Entry Details Modal =========== */}
      <Modal
        open={newPaymentEntry}
        // onClose={() => setOpenServiceDropdown(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50%', sm: '50%' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 0,
            width: { xs: "95%"},
            minHeight: '25%',
            maxHeight: '90%'
          }}

          borderRadius={2}
        >
          <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
              New Payment Entry
            </Typography>
            <IconButton
              size='small'
              onClick={()=>setNewPaymentEntry(false)}
              sx={{ p: 0 }}
              color='error'
            >
              <CloseIcon sx={{fontSize:{xs:'1rem',sm:'1.25rem'}}}/>
            </IconButton>
          </Box>
          {/* <PaymentDescription/> */}
          <AddPaymentRecord bookingDetails={bookingDetailsdata} closePaymentEntryDialog={()=>setNewPaymentEntry(false)} fetchBookingDetalById={fetchBookingDetalById}/>
        </Box>
      </Modal>
      {/* ========== Payment History Details Modal =========== */}
      <Modal
        open={showPaymentHistory}
        // onClose={() => setOpenServiceDropdown(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "scroll" }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: { xs: '50%', sm: '50%' },
            left: '50%',
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            p: 0,
            width: { xs: "95%"},
            minHeight: '25%',
            maxHeight: '90%'
          }}

          borderRadius={2}
        >
          <Box sx={{ borderBottom: '1px solid lightGray', display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: '1% 2%' }}>
            <Typography sx={{ fontWeight: 600, fontSize: '.9rem' }} >
              Payment Record History
            </Typography>
            <IconButton
              size='small'
              onClick={()=>setShowPaymentHistory(false)}
              sx={{ p: 0 }}
              color='error'
            >
              <CloseIcon sx={{fontSize:{xs:'1rem',sm:'1.25rem'}}}/>
            </IconButton>
          </Box>
          <PaymentRecordsList  fetchList={fetchBookingPaymentRecords} paymentRecords={paymentRecords} loading={loading} fetchBookingDetalById={fetchBookingDetalById}/>
          {/* <PaymentDescription/> */}
          {/* <AddPaymentRecord bookingDetails={bookingDetailsdata} closePaymentEntryDialog={()=>setNewPaymentEntry(false)}/> */}
        </Box>
      </Modal>
    </Card>
  );
}

export default PaymentDetails;
